import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { browserHistory } from 'react-router';
import { Thread } from './elements';
import { Loader } from '../../../../common/elements';
import {
    getCurrentThread,
    getThreadPosts
} from '../../../../../actions/forums/forums';

class SingleThread extends Component {

    componentDidMount() {
        const { params, getCurrentThread, getThreadPosts } = this.props;
        getCurrentThread( params.threadId );
        getThreadPosts( params.threadId, 1 );
    };

    getNextPosts = ( pageId ) => {
        const { params, getThreadPosts } = this.props;
        getThreadPosts( params.threadId, pageId );
		browserHistory.push( `/forums/${ params.categoryId }/threads/${ params.threadId }?page=${ pageId }` );
    }

    render() {

        const { 
            params, 
            thread, 
            posts, 
            paging, 
            location 
        } = this.props;

        if( !thread || !posts || !paging ) {
            return <Loader  />;
        }

        if( thread ) {
            return (
                <Thread thread={ thread }
                        threadId={ params.threadId }
                        posts={ posts }
                        paging={ paging }
                        location={ location }
                        getNextPosts={ ( page ) => this.getNextPosts( page ) }
                />
            );
        }
    };
}

SingleThread.propTypes = {
	thread: PropTypes.object,
	paging: PropTypes.object,
	params: PropTypes.object,
	location: PropTypes.object,
	posts: PropTypes.array,
	getCurrentThread: PropTypes.func,
	getThreadPosts: PropTypes.func
}

const mapStateToProps = ( state ) => {
    return {
        thread: state.forums.current_thread,
        posts: state.forums.posts,
        paging: state.forums.pagination,
    };
};

const mapDispatchToProps = ( dispatch ) => {
    return {
        getCurrentThread: ( threadId ) => dispatch( getCurrentThread( threadId ) ),
        getThreadPosts: ( threadId, page ) => dispatch( getThreadPosts( threadId, page ) ),
    };
};
export default connect( mapStateToProps, mapDispatchToProps )( SingleThread );



// WEBPACK FOOTER //
// src/client/components/site/features/forums/pages/SingleThread.js